import Header from "../Partials/Header";
import Loading from "../Components/Loading";
import { useState, useEffect, useRef, useContext } from "react";
import { getFactory, renewLicense } from "../Utils/APIFetching";
import { useParams } from "react-router-dom";
import { HiOutlinePrinter } from "react-icons/hi";
import { MdAutorenew } from "react-icons/md";
import { ComponentToPrint } from "./Print";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-hot-toast";
import { AuthContext } from "../Utils/AuthContext";
function License() {
  const { userInfo } = useContext(AuthContext);
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [factory, setFactory] = useState({});

  const [renewModal, setRenewModal] = useState(false);
  const [renewIssuedAt, setRenewIssuedAt] = useState("");
  const [renewExpireAt, setRenewExpireAt] = useState("");

  useEffect(() => {
    getFactoryDetails();
  }, []);

  function getFactoryDetails() {
    getFactory(slug)
      .then((res) => {
        return res;
      })
      .then((res) => {
        setFactory(res.data.factory);
        setLoading(false);
      });
  }

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  function addOneYear(dateStr) {
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return "";

    d.setUTCFullYear(d.getUTCFullYear() + 1);
    return d.toISOString().split("T")[0];
  }

  function handleOpenRenewModal() {
    const today = new Date().toISOString().split("T")[0];
    setRenewIssuedAt(today);
    setRenewExpireAt(addOneYear(today));
    setRenewModal(true);
  }

  function handleRenewIssuedAtChange(e) {
    const nextIssuedAt = e.target.value;
    setRenewIssuedAt(nextIssuedAt);
    setRenewExpireAt(addOneYear(nextIssuedAt));
  }

  function handleConfirmRenew() {
    if (!renewIssuedAt) {
      toast.error("Please select an issued date");
      return;
    }

    toast.promise(
      renewLicense(factory.slug, {
        issuedAt: renewIssuedAt,
        expireAt: renewExpireAt,
      }),
      {
        loading: "Renewing License",
        success: (res) => {
          if (res?.data?.factory) {
            setFactory(res.data.factory);
          } else {
            getFactoryDetails();
          }
          setRenewModal(false);
          return res.data.message;
        },
        error: (err) => err.response?.data?.message || "Failed to renew license",
      }
    );
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <Header />
      {renewModal && <RenewModal />}

      <div className="m-10  z-0">
        <div className="flex justify-end my-2 space-x-2">
          {new Date().toISOString() > factory.license.expireAt && (
            <>
              {(userInfo.role === "Admin" || userInfo.role === "Licenser") && (
                <button
                  className="bg-red-500 py-2 px-3 text-white flex items-center"
                  onClick={handleOpenRenewModal}
                >
                  <MdAutorenew size={20} className="mr-1" />
                  Renew License
                </button>
              )}
            </>
          )}
          <button
            className="bg-blue-500 py-2 px-3 text-white flex items-center"
            onClick={handlePrint}
          >
            <HiOutlinePrinter size={20} className="mr-1" />
            Print
          </button>
        </div>
        <ComponentToPrint ref={componentRef} factory={factory} />
      </div>
    </div>
  );

  function RenewModal() {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 bg-white m-auto p-10 w-11/12 md:w-2/5">
          <h2 className="text-xl text-center">Renew License</h2>

          <div className="mt-6 space-y-4">
            <div>
              <label className="block text-sm text-gray-600 mb-1">
                Renewed At
              </label>
              <input
                type="date"
                className="w-full p-3 bg-white border"
                value={renewIssuedAt}
                onChange={handleRenewIssuedAtChange}
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">
                Expires At
              </label>
              <input
                type="date"
                className="w-full p-3 bg-gray-100 border"
                value={renewExpireAt}
                disabled
              />
            </div>
          </div>

          <div className="space-x-2 mt-6 text-center">
            <button
              className="bg-green-500 text-white text-lg px-6 py-2"
              onClick={handleConfirmRenew}
            >
              Renew
            </button>
            <button
              className="bg-black text-white text-lg px-6 py-2"
              onClick={() => setRenewModal(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default License;
